import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import scanFiltersApi from "../../API/scanFilters.api";
import { longDateTime } from "../../utils/DateHelper";
import FilterHistoryDropdown from "./filterHistoryDropdown";

const RecentFiltersForm = ({
    recentFilters,
    setRecentFilters,
    selectedRecentFilter,
    setSelectedRecentFilter,
    applyRecentFilter,
    materialsLookup,
}) => {
    const [recentFiltersLoading, setRecentFiltersLoading] = useState(false);
    const filtersPerPage = 20;

    useEffect(() => {
        if (!isEmpty(materialsLookup)) fetchRecentFilters();
    }, [materialsLookup]);

    const fetchRecentFilters = async () => {
        setRecentFiltersLoading(true);
        let result = await scanFiltersApi.listScanFilters(filtersPerPage);
        const mappedResult = mapScanFilters(result?.data);
        setRecentFilters(mappedResult);
        setRecentFiltersLoading(false);
    };

    const mapScanFilters = (data) => {
        return data && !isEmpty(data)
            ? data.map((scanFilter) => {
                  return {
                      ...scanFilter,
                      lastUpdatedAt: new Date(scanFilter.lastUpdatedAt),
                      value: scanFilter.id,
                      label: renderDropdownStyle(scanFilter),
                  };
              })
            : [];
    };

    const renderDropdownStyle = (filter) => {
        return (
            <span className="flex items-center justify-between gap-1">
                <span className="flex items-center gap-1">
                    {filter.name}
                    <span className="text-xxs text-primary-color-orange">
                        ({filter.material?.name?.trim()})
                    </span>
                </span>
                {longDateTime(new Date(filter.lastUpdatedAt))}
            </span>
        );
    };

    return (
        <FilterHistoryDropdown
            recentFiltersLoading={recentFiltersLoading}
            recentFilters={recentFilters}
            recentFilter={selectedRecentFilter}
            setRecentFilter={setSelectedRecentFilter}
            applyRecentFilter={applyRecentFilter}
        />
    );
};

export default RecentFiltersForm;
